import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { RsbService } from 'src/app/service/rsb.service';

@Component({
  selector: 'app-assign-staff-popup',
  templateUrl: './assign-staff-popup.component.html',
  styleUrls: ['./assign-staff-popup.component.css']
})
export class AssignStaffPopupComponent implements OnInit {
  userTypeName: string = '';
  allStaffRecords:Array<any> = [];
  constructor(public rsbLookup: RsbLookupModel,
    private rsbService: RsbService,
    private router: Router,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.userTypeName = this.rsbLookup.getLoggedUser().type;
    this.getStaffMembers()

  }

  getStaffMembers(): void {

    this.rsbService.getStaffDataWithoutPagination('staff').subscribe((rsp) => {
      if(rsp.statusCode === 0 && rsp.contents.length > 0) {
        this.allStaffRecords = rsp.contents
      }
    })
  }

  assign(record:any): void {
    this.activeModal.close(record);

  }

}
